import React from "react";
import { useNavigate } from "react-router-dom";
import { useStore } from "react-redux";
import { Spin } from "antd";
import { useIsAuth, useVkBootstrapping } from "@redux";
import Auth from "components/auth/auth";

/**
 * Защита маршрутов: без sessionId показывается диалог Auth.
 * Пока идёт VK-автологин — спиннер. После закрытия без входа — назад или /home.
 */
const RequireAuth = ({ children }) => {
  const isAuth = useIsAuth();
  const vkBootstrapping = useVkBootstrapping();
  const store = useStore();
  const navigate = useNavigate();

  const handleAuthClose = () => {
    if (store.getState().user?.sessionId) {
      return;
    }
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/home", { replace: true });
    }
  };

  if (vkBootstrapping) {
    return (
      <div className="app-loading">
        <Spin size="large" />
      </div>
    );
  }

  if (!isAuth) {
    return <Auth open onClose={handleAuthClose} />;
  }

  return children;
};

export default RequireAuth;
